import Vue from 'vue';
import AuditlogService from './auditlogs.service';

const getDefaultState = () => ({
    list: [],
});

const auditlogs = {
    namespaced: true,

    state: Object.assign({}, getDefaultState()),

    mutations: {
        updateList(state, data) {
            Vue.set(state, 'list', data);
        },
        clear(state) {
            Vue.set(state, 'list', JSON.parse(JSON.stringify(getDefaultState().list)));
        },
    },

    actions: {
        clear({ commit }) {
            commit('clear');
        },
        async queryByBook(context, params) {
            const { data } = await AuditlogService.queryByBook(params);
            context.commit('updateList', data);
            return data;
        },
    },

    getters: {
        list(state) {
            return state.list;
        },
    },
};

export default auditlogs;
